import styled from 'styled-components';
import { palette } from 'styled-theme';

const LayoutContentStyle = styled.div`
  width: 100%;
  padding: 30px;
  background-color: #ffffff;
  border: 1px solid ${palette('border', 0)};
  height: 100%;
  box-shadow : 0px 0px 36px #e4e4ec;
`;

export default LayoutContentStyle;
